module.exports = __webpack_public_path__ + "img/arrastrar.43f2d1c3.svg";